import styled from 'styled-components'

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`
